import { TicketDocumentV1Dto } from '@/openapi';

function isAcceptedOperatingCostDocument(document: TicketDocumentV1Dto): boolean {
  const acceptedInvoiceTypes = [
    TicketDocumentV1Dto.documentType.OPERATING_COST_INVOICE,
    TicketDocumentV1Dto.documentType.OPERATING_COST_CORRECTION,
  ]
    .map((type) => String(type ?? '').toLowerCase())
    .filter((type) => type.length > 0);

  return acceptedInvoiceTypes.includes(String(document.documentType ?? '').toLowerCase());
}

function hasDocumentInternalId(document: TicketDocumentV1Dto): boolean {
  return (
    typeof document.documentInternalId === 'string' && document.documentInternalId.trim().length > 0
  );
}

export function getOperatingCostDocumentInternalId(
  documents: TicketDocumentV1Dto[] | null | undefined,
): string | null {
  const matchingDocuments = (documents ?? []).filter(isAcceptedOperatingCostDocument);

  const preferredAttachment = matchingDocuments.find((document) => {
    return document.kind === TicketDocumentV1Dto.kind.ATTACHMENT && hasDocumentInternalId(document);
  });

  if (preferredAttachment) {
    return preferredAttachment.documentInternalId.trim();
  }

  const fallbackDocument = matchingDocuments.find(hasDocumentInternalId);
  return fallbackDocument ? fallbackDocument.documentInternalId.trim() : null;
}
